import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { get, filter, size, concat, forEach, includes } from "lodash";

import { fetchPost } from "../../../api/fetch";

import OccurrenceForm from "./OccurrenceForm";

import { setToMidnight, toTimeZone, toUTCTimestamp } from "../../../utils/date";
import { HSP, MDC } from "../../../constants/common";

const AddOccurrence = (props) => {
  const { language, open, setOpen, timeSlots, initialDate, refresh } = props;
  const [isSaving, setIsSaving] = React.useState(false);

  const type = get(props, ["history", "location", "pathname"]).includes("mdc")
    ? MDC
    : HSP;
  const filters = get(props, ["filters", type]);

  const initialValues = {
    timeType: "timeSlots",
    recurrence: {
      repeat: "noRepeat",
    },
    scheduleType: 3,
    site: get(filters, ["site"]),
    startDate: initialDate
      ? setToMidnight(new Date(initialDate))
      : setToMidnight(new Date()),
    timeSlot: props.initialTimeSlot || 1,
  };

  const submit = async (formValues) => {
    setIsSaving(true);
    try {
      let start, end;

      if (get(formValues, ["timeType"]) === "timeSlots") {
        const timeSlot = get(
          filter(timeSlots, (t) => t.id === get(formValues, ["timeSlot"])),
          [0]
        );

        start = toTimeZone(get(formValues, ["startDate"]))
          .hours(get(timeSlot, ["start", "hours"]))
          .minutes(get(timeSlot, ["start", "minutes"]))
          .valueOf();
        end = toTimeZone(get(formValues, ["startDate"]))
          .hours(get(timeSlot, ["end", "hours"]))
          .minutes(get(timeSlot, ["end", "minutes"]))
          .valueOf();
      } else if (get(formValues, ["timeType"]) === "custom") {
        start = toTimeZone(get(formValues, ["startDate"]))
          .hours(toTimeZone(get(formValues, ["customStart"])).hours())
          .minutes(toTimeZone(get(formValues, ["customStart"])).minutes())
          .valueOf();
        end = toTimeZone(get(formValues, ["startDate"]))
          .hours(toTimeZone(get(formValues, ["customEnd"])).hours())
          .minutes(toTimeZone(get(formValues, ["customEnd"])).minutes())
          .valueOf();
      }

      const occurrenceDuration = (end - start) / 60000;

      // Attributes
      let attributes = [];
      if (get(formValues, ["comment"])) {
        attributes.push({
          id: 19,
          value: get(formValues, ["comment"]),
        });
      }

      // Zones
      // let zones = [
      //   {
      //     id: get(formValues, ["zone"]),
      //     active: true,
      //     // schedule_seq_datetime: 1618329700000,
      //     // sequence: 0,
      //   },
      // ];

      let zones = [
        {
          zone_id: get(formValues, ["zone"]),
          active: true,
          // schedule_seq_datetime: 1618329700000,
          // sequence: 0,
        },
      ];

      //Profiles
      let profiles = [];
      const profileIds = concat(
        [get(formValues, ["host", "id"])],
        get(formValues, ["visitors"]) || [],
        new Array(size(get(formValues, ["unknownVisitors"]))).fill(
          "00000000-0000-0000-0000-000000000000"
        )
      );
      forEach(profileIds, (p, i) => {
        profiles.push({
          profile_id: p,
          association_type_id: i === 0 ? 1 : 2,
          active: true,
          // schedule_seq_datetime: 1618329700000,
          // sequence: 0,
        });
      });

      // let profiles = [];
      // const profileIds = concat(
      //   [get(formValues, ["host", "id"])],
      //   get(formValues, ["visitors"]) || [],
      //   new Array(size(get(formValues, ["unknownVisitors"]))).fill(
      //     "00000000-0000-0000-0000-000000000000"
      //   )
      // );
      // forEach(profileIds, (p, i) => {
      //   profiles.push({
      //     id: p,
      //     association_type_id: i === 0 ? 1 : 2,
      //     active: true,
      //     // schedule_seq_datetime: 1618329700000,
      //     // sequence: 0,
      //   });
      // });

      // Recurrence
      let when = {};
      let recurring = false;
      if (
        includes(
          ["weekly", "daily", "monthly"],
          get(formValues, ["recurrence", "repeat"])
        )
      ) {
        const endsOn = toTimeZone(get(formValues, ["recurrence", "endsOn"]));
        end = toTimeZone(end)
          .year(endsOn.year())
          .month(endsOn.month())
          .date(endsOn.date())
          .valueOf();

        recurring = true;
        when = {
          starts_on: toUTCTimestamp(start),
          ends_on: toUTCTimestamp(end),
        };

        // Weekly recurrence
        if (get(formValues, ["recurrence", "repeat"]) === "weekly") {
          when = {
            type: "weekly",
            weekdays: get(formValues, ["recurrence", "on"]),
            time: toUTCTimestamp(start),
            every: get(formValues, ["recurrence", "every"]),
          };
        }
        // Daily recurrence
        else if (get(formValues, ["recurrence", "repeat"]) === "daily") {
          when = {
            type: "period",
            period_in_minutes:
              1440 * parseInt(get(formValues, ["recurrence", "every"])),
          };
        }
        // Monthly recurrence
        else if (get(formValues, ["recurrence", "repeat"]) === "monthly") {
          when = {
            type: "monthly",
            monthdays: [get(formValues, ["recurrence", "on"])],
            time: toUTCTimestamp(start),
            every: get(formValues, ["recurrence", "every"]),
          };
        }
      } else {
        when = {
          type: "single",
          datetime: toUTCTimestamp(start),
        };
      }

      let schedule = {
        active: true,
        type_id: get(formValues, ["scheduleType"]),
        status_id: 2,
        name: {
          en: "",
          fr: "",
        },
        description: {
          en: "",
          fr: "",
        },
        "company_id": 2,
        "color_id": 0,
        "json": "string",
        "attributes": [
            {
                "id": 3,
                "value": "string",
                "active": true
            }
        ],
        recurring,
        site_id: get(formValues, ["site"]),
        starts_on: toUTCTimestamp(start),
        ends_on: toUTCTimestamp(end),
      };
      if (get(formValues, ["scheduleName"])) {
        schedule.name[language] = get(formValues, ["scheduleName"]);
      }

      // let schedule = {
      //   active: true,
      //   type_id: get(formValues, ["scheduleType"]),
      //   status_id: 2,
      //   name: {
      //     en: "",
      //     fr: "",
      //   },
      //   description: {
      //     en: "",
      //     fr: "",
      //   },
      //   recurring,
      //   site_id: get(formValues, ["site"]),
      //   starts_on: toUTCTimestamp(start),
      //   ends_on: toUTCTimestamp(end),
      // };
      // if (get(formValues, ["scheduleName"])) {
      //   schedule.name[language] = get(formValues, ["scheduleName"]);
      // }

      // schedule = await fetchPost("schedules", schedule);
      // schedule = get(schedule, [0]);

      //Create occurrences
      let occurrences = {
        schedule_id: get(schedule, ["id"]),
        "active": true,
        "color_id": 1,
        occurrences:
          {
            when,
            status_id: 2,
            //active: true,
            //color_id: 1,
            attributes,
            events: [
              {
                event_type_id: 1,
                status_id: 2,
                relative_time_minutes: 0,
                // tolerance_min: {
                //   before:
                //   after:
                // },
                active: true,
                profiles,
                zones,
                duration: occurrenceDuration,
                //instructions: []
              },
              {
                event_type_id: 2,
                status_id: 2,
                relative_time_minutes: occurrenceDuration,
                // tolerance_min: {
                //   before:
                //   after:
                // },
                active: true,
                profiles,
                duration: occurrenceDuration,
                zones,
                //instructions: []
              },
            ],
          }
      };
      // let occurrences = {
      //   action: "create",
      //   schedule_id: get(schedule, ["id"]),
      //   occurrences: [
      //     {
      //       when,
      //       status_id: 2,
      //       //active: true,
      //       //color_id: 1,
      //       attributes,
      //       events: [
      //         {
      //           event_type_id: 1,
      //           status_id: 2,
      //           relative_time_minutes: 0,
      //           // tolerance_min: {
      //           //   before:
      //           //   after:
      //           // },
      //           active: true,
      //           profiles,
      //           zones,
      //           //instructions: []
      //         },
      //         {
      //           event_type_id: 2,
      //           status_id: 2,
      //           relative_time_minutes: occurrenceDuration,
      //           // tolerance_min: {
      //           //   before:
      //           //   after:
      //           // },
      //           active: true,
      //           profiles,
      //           zones,
      //           //instructions: []
      //         },
      //       ],
      //     },
      //   ],
      // };

      //await fetchPost("schedules/occurrences", occurrences);
      var payload = Object.assign(schedule, occurrences)
      await fetchPost("schedules", payload);

    } catch (e) {
      console.log(e);
    }
    setIsSaving(false);
    setOpen(false);
    refresh();
  };

  return (
    <OccurrenceForm
      open={open}
      setOpen={setOpen}
      setIsSaving={setIsSaving}
      initialValues={initialValues}
      submit={submit}
      timeSlots={timeSlots}
      isSaving={isSaving}
      type={type}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    language: get(state, ["user", "language"]),
    filters: get(state, ["scheduler", "filters"]),
  };
};

export default withRouter(connect(mapStateToProps)(AddOccurrence));